import { useCallback, useEffect, useState } from 'react';
import { ButtonField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem, InputField, TextareaField, SelectField } from '@wk/components-react16';
import { API_URL } from '../../../config/constants';
import HttpService from "../../../config/http.service";
import { Toast } from '../../../services';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { hideLoading, showLoading } from '../../../store/authReducer';

const AddPromptType = ({ data }: any) => {
    const dispatch = useDispatch();
    const { isOpenAddEdit, setIsOpenAddEdit, selectedItem, setIsLoad } = data;
    const { authProject } = useSelector((state: RootState) => state.auth);
    const defaultFormObj = {
        id: selectedItem.id ? selectedItem.id : null,
        name: selectedItem.name ? selectedItem.name :"",
        code: selectedItem.code ? selectedItem.code : "",
        description: selectedItem.description ? selectedItem.description : "",
        projectId: selectedItem.projectId ? selectedItem.projectId : authProject.id,
        gptAgent: selectedItem.gptAgent || ""
    };
    const [formField, setFormField] = useState(defaultFormObj);
    const [agentList, setAgentList] = useState([] as any);

    const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            setIsOpenAddEdit(false);
        }
    }

    const handleInputChange = (event: any) => {
        const { name, value } = event.target;
        setFormField({
            ...formField,
            [name]: value
        });
    };

    const isValidInput = (formObj: any) => {
        if (!formObj.name || !formObj.name.trim()) {
            Toast('Please enter prompt type name', "error");
            return false;
        }
        if (!formObj.code || !formObj.code.trim()) {
            Toast('Please enter prompt type code', "error");
            return false;
        }
        if (!formObj.description || !formObj.description.trim()) {
            Toast('Please enter prompt type description', "error");
            return false;
        }
        return true;
    }

    const handlePromptType = () => {
        if (!isValidInput(formField)) return;
        dispatch(showLoading());
        HttpService.postRequest(API_URL.ADD_PROMPT_TYPE, formField).then(
            (res: any) => {
                Toast(selectedItem?.id ? 'Prompt type updated successfully.' : 'Prompt type added successfully.', "success");
                setIsOpenAddEdit(false);
                setIsLoad(true);
                dispatch(hideLoading());
            },
            (err: any) => {
                Toast(err.message, "error");
                dispatch(hideLoading());
            }
        );
    }

    const generateCode = () => {
        if (!formField.name || !formField.name.trim()) {
            Toast('Please enter prompt type name', "error");
            return false;
        }
        HttpService.postRequest(API_URL.GENERATE_CODE, formField.name).then(
            (res: any) => {
                setFormField({
                    ...formField,
                    code: res ? res : null
                });
            }
        ).catch((err: any) => {
            Toast(err.message, "error");
        });
    }

    const getAgentList =  useCallback(() => {
        dispatch(showLoading());
        HttpService.getRequest(`${API_URL.GET_AGENT_LIST}`).then(
            (res: any) => {
                    setAgentList(res ? res : []);
                    dispatch(hideLoading());
                },
                (err: any) => {
                    Toast(err.message, "error")
                    dispatch(hideLoading());
            },
        )
    }, []);

    useEffect(() => {
        getAgentList();
    }, [getAgentList]);

    return (
        <div>
            <Modal
                isOpen={isOpenAddEdit}
                srLabelledBy={'modal-id-prompttype'}
                srDescribedBy={'modal-id-prompttype'}
                onUserRequest={handleUserRequest}>
                <ModalHeader
                    titleId={'modal-id-prompttype'}
                    isFullscreenButtonVisible={false}
                    onUserRequest={() => handleUserRequest('header')}>
                    {selectedItem?.id ? 'Edit Prompt Type' : 'Add Prompt Type'}
                </ModalHeader>
                <ModalBody descriptionId="modal-id-prompttype">
                    <div className='wk-grid-page-container p-0'>
                        <div className="wk-grid mt-10">
                            <div className="wk-column-12">
                                <InputField label="Name" labelFor="prompttype-name-1" size="small" indicator="required">
                                    <input
                                        type="text" id="prompttype-name-1" name="name"
                                        placeholder="Prompt Type Name"
                                        onChange={(event: any) => handleInputChange(event)}
                                        value={formField.name} autoComplete="off"
                                    />
                                </InputField>
                                <div className="cg-field-header">
                                    <label className="cg-field-label pt-15">Code <div className="cg-field-required-indicator"><span aria-hidden="true">*</span><div data-e2e="cg-sr-only" className="cg-sr-only">Required field</div></div></label>
                                    <div className="pt-5">
                                        <button type="button" className="border border-primary btn btn btn-outline-light text-bg-light"
                                            style={{ padding: '.25rem .5rem', fontSize: '.75rem', color: '#9A67F3' }}
                                            onClick={generateCode}>
                                            Generate Code
                                        </button>
                                    </div>
                                </div>
                                <InputField label="" labelFor="prompttype-code-1" size="small" indicator="required">
                                    <input
                                        type="text" id="prompttype-code-1" name="code"
                                        placeholder="Prompt Type Code"
                                        readOnly
                                        value={formField.code} autoComplete="off"
                                    />
                                </InputField>
                                <div className="">
                                    <TextareaField label="Description" labelFor="prompttype-description-1" indicator="required">
                                        <textarea style={{ height: '10rem' }}
                                            id="prompttype-code-1" name="description"
                                            placeholder="Prompt Type Description"
                                            onChange={(event: any) => handleInputChange(event)}
                                            value={formField.description}
                                        ></textarea>
                                    </TextareaField>
                                </div>
                                <SelectField size={'small'} label="GPT Agent" labelFor="select-id-gpt-agent">
                                    <select id="select-id-agent" name="gptAgent" value={formField.gptAgent}
                                        onChange={(event: any) => handleInputChange(event)}>
                                        <option value="">-- Select Agent --</option>
                                        {agentList.length > 0 ? agentList.map((item: any, index: number) => (
                                            <option value={item.name} key={index}>{item.name}</option>
                                        )) : null}
                                        {/* <option value="cpm-gpt">cpm-gpt (default)</option>
                                        <option value="cpm-obligation">cpm-obligation</option>
                                        <option value="cpm-clustering">cpm-clustering</option>
                                        <option value="cpm-clustering-test">cpm-clustering-test</option>
                                        <option value="cpm-tagging">cpm-tagging</option>
                                        <option value="cpm-authoring">cpm-authoring</option>
                                        <option value="cpm-validation">cpm-validation</option>
                                        <option value="cpm-regchange">cpm-regchange</option>
                                        <option value="cpm-impact-cluster">cpm-impact-cluster</option>
                                        <option value="cpm-citation-preprocessing">cpm-citation-preprocessing</option>
                                        <option value="brief-genius-gpt">brief-genius-gpt</option>
                                        <option value="cr-process-content">cr-process-content</option>
                                        <option value="cr-chat-with-pdf">cr-chat-with-pdf</option> */}
                                    </select>
                                </SelectField>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'} iconPosition={'left'}>
                                <button
                                    className='mr-10'
                                    type="button"
                                    id="save"
                                    onClick={handlePromptType}>
                                    Save
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default AddPromptType;